import React from 'react'

import { useNavigate } from 'react-router'

import { CardCoach, CardDashboard, Section } from '../../../..'
import { useUser } from '../../../../../context'
import { Student, URLNavigation } from '../../../../../types'
import { ContentRoutineSection } from '../../../../Cards/CardDashboard/styles'
import { Spacer } from '../../../../global'

const routeData = [
  {
    tag: 'Tu Rutina-ah!',
    description:
      'Accede a tu material de trabaja y continúa con tu entrenamiento',
  },
  {
    tag: 'Dropbox-Grabaciones',
    description: 'Ten acceso a todas tus grabaciones',
  },
  {
    tag: 'Chat con profesores',
    description: 'Habla con tus profesores',
  },
]

const IndividualClassSection = () => {
  const navigate = useNavigate()
  const { user } = useUser()

  const handleNavegation = (section: number) => {
    return section === 0
      ? navigate(URLNavigation.ROUTINE)
      : section === 2
        ? navigate(URLNavigation.CHAT)
        : window.open((user as Student)?.dropboxLink || '', '_blank')
  }

  return (
    <>
      <Section title="Ruta-ah! recomendada" childrenClass="route-children">
        <ContentRoutineSection>
          {routeData.map((routine, index) => {
            return (
              <CardDashboard
                key={index}
                tagText={routine.tag}
                description={routine.description}
                img={
                  index === 1
                    ? '/assets/miguel-bautista-book-2.png'
                    : index === 2
                      ? '/assets/miguel-bautista-book-3.png'
                      : '/assets/miguel-bautista-img-book.png'
                }
                color="yellow"
                tagPosition="bottom"
                cardSize="sm"
                onClick={() => handleNavegation(index)}
              />
            )
          })}
        </ContentRoutineSection>
      </Section>
      <Spacer height={20} />
      <Section
        title="Conoce a los mienbros de tú Academi-ah!"
        childrenClass="individual-class"
      >
        <CardCoach />
      </Section>
    </>
  )
}

export default IndividualClassSection
